
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CorrectTestState {
    count: number;
}

const initialState: CorrectTestState = {
    count: 0,
};

const correctTestSlice = createSlice({
    name: 'correctTest',
    initialState,
    reducers: {
        incrementCorrectTestCount: (state, action: PayloadAction<number>) => {
            state.count += action.payload;
        },
        resetCorrectTestCount: (state) => {
            state.count = 0;
        },
    },
});

export const {
    incrementCorrectTestCount,
    resetCorrectTestCount,
} = correctTestSlice.actions;

export const correctTestReducer = correctTestSlice.reducer;
